import { MatDialogConfig } from "@angular/material/dialog";
import { MOBILE_SLIDE_OUT_DURATION } from "./mobile-slide-in-dialog";

/** Must match the `max-width: 639.98px` block for `.confirmation-dialog--bottom-sheet` in material-ui.scss. */
export const MOBILE_BOTTOM_SHEET_BREAKPOINT = "(max-width: 639.98px)";

export const MOBILE_BOTTOM_SHEET_DIALOG = "confirmation-dialog--bottom-sheet";

/**
 * Spread into the config of a pop-up that only needs part of the screen (a confirmation, alert or
 * info pop-up), in place of its `panelClass`. On mobile the pop-up then docks to the bottom, slides
 * up and is only as tall as its content; desktop keeps the centred card.
 *
 * The exit time is picked when the dialog opens, for the same reason as `mobileSlideInConfig`:
 * Material's 75ms default would remove the sheet before its 200ms slide-out finishes.
 */
export function mobileBottomSheetConfig(
  panelClass = "confirmation-dialog",
): Pick<MatDialogConfig, "panelClass" | "exitAnimationDuration"> {
  const config = { panelClass: [panelClass, MOBILE_BOTTOM_SHEET_DIALOG] };
  return isMobileBottomSheetViewport()
    ? { ...config, exitAnimationDuration: MOBILE_SLIDE_OUT_DURATION }
    : config;
}

/** `matchMedia` isn't available in every runtime (SSR/tests), so default to `false` (desktop). */
function isMobileBottomSheetViewport(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(MOBILE_BOTTOM_SHEET_BREAKPOINT).matches;
}
